<template>
  <div class="row">
    <div class="col-md-6">
      <card>
        <template slot="header">
          <h4 class="card-title">Update status with Import File</h4>
        </template>
        <el-form ref="form" :model="form" label-width="140px">
          <el-form-item label="Status">
            <el-select v-model="form.status" placeholder="select status" name="status" v-validate="'required'" >
              <el-option label="Over" value="Over"></el-option>
              <el-option label="No Show" value="No Show"></el-option>
              <el-option label="Unmanifest" value="Unmanifest"></el-option>
              <el-option label="CAT4" value="CAT4"></el-option>
            </el-select>
            <span class="el-form-item__error">{{ errors.first('status') }}</span>
          </el-form-item>

          <el-form-item label="Description">
            <el-input
              type="textarea"
              autosize
              placeholder="Description"
              v-model="form.description">
            </el-input>
          </el-form-item>
          <el-form-item label="File">
              <el-upload
                class="upload-demo"
                ref="upload"
                accept=".xlsx"
                :headers="uploadHeaders"
                :data="form"
                :action="uploadURI"
                :auto-upload="false"
                :on-success="handleUploadSuccess"
                :on-error="handleUploadError"
                :before-upload="beforeUpload"
              >
                <p-button
                  slot="trigger"
                  size="small"
                  type="primary"
                  :disabled="!form.status ? true : false"
                >select file</p-button>
                <div class="el-upload__tip" slot="tip">xlsx file.</div>
              </el-upload>
          </el-form-item>
          <!-- <div class="form-group">
            <label class="col-sm-2 control-label">File</label>
            <div class="col-sm-10">
              <el-upload
                class="upload-demo"
                ref="upload"
                accept=".xlxs"
                :auto-upload="false"
              >
                <p-button
                  slot="trigger"
                  size="small"
                  type="primary"
                >select file</p-button>
                <div class="el-upload__tip" slot="tip">xlsx file.</div>
              </el-upload>
            </div>
          </div> -->

          <el-form-item>
                <p-button
                  style="margin-left: 10px;"
                  size="small"
                  type="success"
                  :disabled="!form.status ? true : false"
                  @click="submitUpload"
                >upload to server</p-button>
            <!-- <el-button type="primary" @click="onSubmit">Create</el-button>
            <el-button @click="reset">Cancel</el-button> -->
          </el-form-item>
        </el-form>
      </card>
    </div>
  </div>
</template>


<script>
import Vue from "vue"
import * as _apiParcel from "@/api/parcel"
import * as _apiMAWB from "@/api/mawb"
import { Card } from
"src/components/UIComponents"
import {
  Upload,
  Loading,
  Table,
  TableColumn,
  Select,
  Option,
  Tabs,
  TabPane,
  Button,
  Tooltip,
  Form,
  FormItem,
  Input,
  Checkbox,
  Notification,
  DatePicker,
  Tag,
  Scrollbar,
  Row,
  Col,
} from "element-ui"
import PPagination from "src/components/UIComponents/Pagination.vue"
Vue.use(Loading)
Vue.use(Table)
Vue.use(TableColumn)
Vue.use(Select)
Vue.use(Option)
Vue.use(Tabs)
Vue.use(TabPane)
Vue.use(Button)
Vue.use(Tooltip)
Vue.use(Form)
Vue.use(FormItem)
Vue.use(Input)
Vue.use(Checkbox)
Vue.use(DatePicker)
Vue.use(Tag)
Vue.use(Scrollbar)
Vue.use(Row)
Vue.use(Col)


export default {
    components: {
    PPagination,
    Card,
    Notification,
    [Upload.name]: Upload,
    },
  data() {
    return {
      form: {
        status: '',
        description: '',
      },
      uploadHeaders: {
        Authorization: ''
      },
      uploadURI: '',
      loading: {}
    }
  },
  mounted () {
    this.uploadURI = process.env.VUE_APP_ROOT_API || 'http://127.0.0.1:5005';
    this.uploadURI = this.uploadURI + '/api/w/import/update_status'
  },
  methods: {
    // onSubmit () {
    //   this.$validator.validateAll().then((result) => {
    //     this.saveNewParcel()
    //   }).catch(() => {
    //     this.$notify({
    //       message: 'Please enter all required information',
    //       type: 'danger'
    //     })
    //   })
    // },
    reset () {
      this.form.hawb = ''
      this.form.description = ''
      this.form.status = ''
      this.$validator.reset()
    },
    handleUploadSuccess(response, file, fileList) {
      console.log('handleUploadSuccess')
      this.closeWrapperFullScreen()
      alert('Uploaded Successfully')
      // this.$refs.upload.clearFiles()
    },
    handleUploadError(err, file, fileList) {
      console.log('handleUploadError')
      this.closeWrapperFullScreen()
      alert('Unsuccessfully,' + JSON.parse(err.message).message)
    },
    beforeUpload(file) {
      console.log('beforeUpload')
      let token = localStorage.getItem('token')
      this.uploadHeaders.Authorization = "Bearer " + token
      this.openWrapperFullScreen()
      return true;
    },
    submitUpload() {
      console.log('submitUpload', this.$refs.upload)
      console.log(this.$refs.upload.fileList)
      this.$refs.upload.submit();
    },
    openWrapperFullScreen() {
      this.loading = this.$loading({
        lock: true,
        text: 'Processing',
        spinner: 'el-icon-loading',
        background: 'rgba(0, 0, 0, 0.9)'
      });
    },
    closeWrapperFullScreen() {
      this.loading.close()
    }
  }
}
</script>
